import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconProducts: React.FC<IconProps> = ({
  size = 27,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 27 27"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M4.6875 8.60413L13.5 12.5208M13.5 12.5208L22.3125 8.60413M13.5 12.5208V22.802" stroke="currentColor" strokeWidth="1.30556"/>
    <path d="M4.6875 18.0785V8.19061C4.6875 7.84665 4.89006 7.53495 5.20438 7.39526L12.793 4.02253C13.2431 3.82248 13.7569 3.82248 14.207 4.02253L21.7956 7.39526C22.1099 7.53495 22.3125 7.84665 22.3125 8.19061V18.0785C22.3125 18.573 22.0331 19.0251 21.5908 19.2462L13.8892 23.097C13.6442 23.2195 13.3558 23.2195 13.1108 23.097L5.40919 19.2462C4.96689 19.0251 4.6875 18.573 4.6875 18.0785Z" stroke="currentColor" strokeWidth="1.30556"/>
  </svg>
);

export default IconProducts;
